import { doc, getDoc, setDoc } from "firebase/firestore";
import { RESTAURANT_CONFIG } from "../types/auth";
import { db } from "../../config/firebaseConfig";
import { HOSTNAME } from "../../config/constants";
import { FEEDBACK } from "../types/feedback";
import { getConfig, getData } from "./menu";
import { uploadFile } from "./admin";
import { setfeedback } from "./feedback";
import { ACTIVE_OUTLET } from "../types/config";
import { getFunctions, httpsCallable } from "firebase/functions";
import { generateManifest } from "../../functions/manifest";

export const setrestaurantConfig = (payload) => async (dispatch) => {
  dispatch({ type: RESTAURANT_CONFIG, payload });
};

export const setInitialRestaurantConfig = (data) => async (dispatch, getState) => {
  const { email } = getState().auth.userData;

  const cloneData = JSON.parse(JSON.stringify(data));

  dispatch(setfeedback({ loading: true, status: "", message: "Updating configuration into database..." }));

  const clientRef = doc(db, "clients", email);
  const configRef = doc(db, "config", HOSTNAME);

  uploadFile(data.companyLogo, dispatch, async (companyLogoURL) => {
    // uploadFile(data.outlets[0].outletLogo, dispatch, async (outletLogoURL) => {
    cloneData.companyLogo = companyLogoURL;
    // cloneData.outlets[0].outletLogo = outletLogoURL;

    const clientData = {
      ...cloneData,
    };

    delete clientData.theme;
    clientData.outletsCount = cloneData.outlets.length;
    delete clientData.outlets;

    const functions = getFunctions();
    const generateManifestJson = httpsCallable(functions, "generateManifestJson");

    const manifestJsonURL = await generateManifestJson({
      hostName: HOSTNAME,
      manifestJsonData: generateManifest({
        restaurantName: cloneData.restaurantName,
        companyLogo: cloneData.companyLogo,
      }),
    });

    const configData = {
      restaurantName: cloneData.restaurantName,
      companyLogo: cloneData.companyLogo,
      theme: cloneData.theme,
      outlets: cloneData.outlets,
      manifestJsonURL: manifestJsonURL.data.downloadUrl,
    };

    const docSnapshot = await getDoc(clientRef);

    if (docSnapshot.exists()) {
      const clientExistingData = docSnapshot.data();
      await setDoc(clientRef, {
        ...clientExistingData,
        ...clientData,
      });
    }

    await setDoc(configRef, {
      ...configData,
    });

    dispatch(setfeedback({ loading: true, status: "s", message: "Updated configuration successfully!" }));
    dispatch(getConfig());

    setTimeout(() => {
      dispatch(setfeedback({ loading: false, status: "", message: "" }));
    }, 2000);
  });
  // });
};

export const updateRestaurantConfig = (data) => async (dispatch, getState) => {
  dispatch(setfeedback({ loading: true, status: "", message: "Updating configuration into database..." }));

  const configRef = doc(db, "config", HOSTNAME);

  if (typeof data.companyLogo !== "string") {
    uploadFile(data.companyLogo, dispatch, async (companyLogoURL) => {
      if (typeof data.outlets[0].outletLogo !== "string") {
        uploadFile(data.outlets[0].outletLogo, dispatch, async (outletLogoURL) => {
          await setDoc(configRef, {
            ...data,
            companyLogo: companyLogoURL,
            outlets: [{ ...data.outlets[0], outletLogo: outletLogoURL }],
          });

          dispatch(getData());

          dispatch(setfeedback({ loading: true, status: "s", message: "Updated configuration successfully!" }));

          setTimeout(() => {
            dispatch(setfeedback({ loading: false, status: "", message: "" }));
          }, 2000);
        });
      } else {
        await setDoc(configRef, { ...data, companyLogo: companyLogoURL });

        dispatch(getData());

        dispatch(setfeedback({ loading: true, status: "s", message: "Updated configuration successfully!" }));

        setTimeout(() => {
          dispatch(setfeedback({ loading: false, status: "", message: "" }));
        }, 2000);
      }
    });
  } else {
    await setDoc(configRef, { ...data });

    dispatch(getData());
    dispatch(setfeedback({ loading: true, status: "s", message: "Updated configuration successfully!" }));

    setTimeout(() => {
      dispatch(setfeedback({ loading: false, status: "", message: "" }));
    }, 2000);
  }
};

export const addOutletConfig = (data) => async (dispatch, getState) => {
  dispatch(setfeedback({ loading: true, status: "", message: "Adding outlet into database..." }));

  const configRef = doc(db, "config", HOSTNAME);

  const configDocSnapshot = await getDoc(configRef);
  if (configDocSnapshot.exists()) {
    const configData = configDocSnapshot.data();

    for (let i = 0; i < configData.outlets.length; i++) {
      if (configData.outlets[i].outletId === data.outletId) {
        dispatch(setfeedback({ loading: true, status: "f", message: "Outlet Name Already Exists!" }));

        setTimeout(() => {
          dispatch(setfeedback({ loading: false, status: "", message: "" }));
        }, 2000);

        return;
      }
    }

    // uploadFile(data.outletLogo, dispatch, async (outletLogoURL) => {
    const newOutletArr = JSON.parse(JSON.stringify(configData.outlets));
    const outletData = JSON.parse(JSON.stringify(data));
    // outletData.outletLogo = outletLogoURL;

    newOutletArr.push(outletData);

    await setDoc(configRef, {
      ...configData,
      outlets: newOutletArr,
    });

    const { restaurantConfig } = getState().config;

    // dispatch(setactiveOutlet({ ...data }));
    dispatch(setrestaurantConfig({ ...restaurantConfig, outlets: [...restaurantConfig.outlets, data] }));
    dispatch(getData(data.outletId));

    dispatch(setfeedback({ loading: true, status: "s", message: "Added outlet successfully!" }));

    setTimeout(() => {
      dispatch(setfeedback({ loading: false, status: "", message: "" }));
    }, 2000);
    // });
  }
};

export const updateOutletConfig = (data) => async (dispatch, getState) => {
  dispatch(setfeedback({ loading: true, status: "", message: "Updating outlet into database..." }));

  const configRef = doc(db, "config", HOSTNAME);

  const configDocSnapshot = await getDoc(configRef);
  if (configDocSnapshot.exists()) {
    const configData = configDocSnapshot.data();
    const newOutletArr = [];

    // if (typeof data.outletLogo !== "string") {
    //   uploadFile(data.outletLogo, dispatch, async (outletLogoURL) => {
    //     configData.outlets.forEach((outletData) => {
    //       if (outletData.outletId === data.outletId) {
    //         newOutletArr.push({ ...data, outletLogo: outletLogoURL });
    //       } else {
    //         newOutletArr.push(outletData);
    //       }
    //     });
    //     await setDoc(configRef, {
    //       ...configData,
    //       outlets: newOutletArr,
    //     });

    //     dispatch(setactiveOutlet({ ...data, outletLogo: outletLogoURL }));
    //     dispatch(getData(data.outletId));

    //     dispatch(setfeedback({ loading: true, status: "s", message: "Updated outlet successfully!" }));

    //     setTimeout(() => {
    //       dispatch(setfeedback({ loading: false, status: "", message: "" }));
    //     }, 2000);
    //   });
    // } else {
    configData.outlets.forEach((outletData) => {
      if (outletData.outletId === data.outletId) {
        newOutletArr.push(data);
      } else {
        newOutletArr.push(outletData);
      }
    });
    await setDoc(configRef, {
      ...configData,
      outlets: newOutletArr,
    });

    dispatch(setactiveOutlet(data));

    dispatch(getData(data.outletId));

    dispatch(setfeedback({ loading: true, status: "s", message: "Updated outlet successfully!" }));

    setTimeout(() => {
      dispatch(setfeedback({ loading: false, status: "", message: "" }));
    }, 2000);
  }
  // }
};

export const setactiveOutlet = (payload) => async (dispatch) => {
  dispatch({ type: ACTIVE_OUTLET, payload });
};
